import React, { useContext } from 'react'
import { LoadingScreenPropsTypes } from './LoadingScreenTypes'

import loadLightIcon from '../../images/icons/load-light.gif'
import loadDarkIcon from '../../images/icons/load-dark.gif'
import { useTheme } from '../../context/ThemeContext'

const LoadingScreen = (props: LoadingScreenPropsTypes) => {

    const {theme} = useTheme()

    return (
        <div className={`loading-screen`}>
            <img src={theme === 'dark' ? loadDarkIcon : theme === 'light' ? loadLightIcon : theme === 'colorful' ? loadLightIcon : ''} alt="" />
        </div>
    )
}

export default LoadingScreen